var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4001 6.99961C13.4001 10.5342 10.5347 13.3996 7.0001 13.3996C3.46548 13.3996 0.600098 10.5342 0.600098 6.99961C0.600098 3.46499 3.46548 0.599609 7.0001 0.599609C10.5347 0.599609 13.4001 3.46499 13.4001 6.99961ZM9.78138 10.9122C8.99672 11.471 8.03679 11.7996 7.0001 11.7996C4.34913 11.7996 2.2001 9.65058 2.2001 6.99961C2.2001 5.96292 2.52875 5.00299 3.08754 4.21832L9.78138 10.9122ZM10.9127 9.78078L4.21893 3.08697C5.00357 2.52823 5.96346 2.19961 7.0001 2.19961C9.65106 2.19961 11.8001 4.34864 11.8001 6.99961C11.8001 8.03625 11.4715 8.99613 10.9127 9.78078Z",
    fill: "#FF385F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocked);
export default __webpack_public_path__ + "static/media/Blocked.15c40b7791b946411e4ba7495c39b6ca.svg";
export { ForwardRef as ReactComponent };